import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';

@Component({
    selector: 'lib-popup-header',
    imports: [CommonModule, MatDividerModule, FlexLayoutModule],
    templateUrl: './popup-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './popup-header.component.scss'
})
export class PopupHeaderComponent {

  @Input() title!: string;
  @Input() prefix!: string;
  @Input() titleIcon!: any;
  @Input() showCreationDate!: any;
  @Input() createdDate!: string;
  @Output() popupClosed = new EventEmitter<any>()
  @Output() isPopupMaximized = new EventEmitter<any>()
  @Input() isMaximized = false;
  @Input() canMaximize = true;
  @Input() useCustomClose = false
  @Input() showLeadsError = false

  constructor(public dialogRef: MatDialogRef<PopupHeaderComponent>) {
  }
  ngOnInit(): void {
    if (this.isMaximized) {
      this.dialogRef.updateSize('100%', '100%');
    } else {
      this.dialogRef.updateSize('80%', '80%');
    }
    this.isPopupMaximized.emit(this.isMaximized)
    this.recenterDialog();
  }

  toggleSize(): void {
    this.isMaximized = !this.isMaximized;
    if (this.isMaximized) {
      this.dialogRef.updateSize('100%', '100%');
    } else {
      this.dialogRef.updateSize('80%', '80%');
    }
    this.isPopupMaximized.emit(this.isMaximized)
    this.recenterDialog();
  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes['createdDate'] && changes['createdDate'].currentValue === null) {
    //   this.createdDate = this.formatDate(new Date());
    // }
  }

  recenterDialog() {
    setTimeout(() => {
      this.dialogRef.updatePosition({ top: '50%', left: '50%' });
      this.dialogRef.updatePosition();
    }, 0);
  }

  formatDate(date): string {
    const options: Intl.DateTimeFormatOptions = {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    };
    if (date) {
      return (new Date(date)).toLocaleString('en-US', options);
    } else {
      return (new Date()).toLocaleString('en-US', options);
    }
  }

  close(): void {
    if(this.useCustomClose) {
      this.popupClosed.emit(true)
    } else {
      this.popupClosed.emit(true)
      this.dialogRef.close();
    }
  }
}
